import React from "react";
import { Button, Carousel } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCirclePause,
  faCirclePlay,
  faExternalLink
} from "@fortawesome/free-solid-svg-icons";
import { useInView } from "react-intersection-observer";

import styles from "./index.module.scss";
import clsx from "clsx";
import { useWindowSize } from "../../hooks/use-device-type";

export interface SliderItemProps {
  mediaUrl: string;
  title: string;
  buttonText: string;
  buttonLink: string;
  links: {
    text: string;
    link: string;
  }[];
  index: number;
  mediaType: "image" | "video";
}

export const SliderItem = (props: SliderItemProps) => {
  const { mediaType, mediaUrl, title, buttonText, buttonLink, links, index } =
    props;
  const isVideo = mediaType === "video";
  const videoRef = React.createRef<HTMLVideoElement>();
  const [isPlaying, setIsPlaying] = React.useState(false);
  const [ref, inView] = useInView();
  const [buttonRef, buttonInView] = useInView();
  const { width } = useWindowSize();
  const isMobile = width < 512;

  return (
    <>
      {isVideo ? (
        <video className={"d-block w-100 " + styles.img} ref={videoRef}>
          <source src={mediaUrl} type="video/mp4" />
        </video>
      ) : (
        <img
          className={"d-block w-100 " + styles.img}
          src={mediaUrl}
          alt={title}
        />
      )}

      {isVideo ? (
        !isPlaying ? (
          <FontAwesomeIcon
            icon={faCirclePlay}
            className={styles.icon}
            onClick={() => {
              setIsPlaying(true);
              // play video
              videoRef.current.play();
            }}
          />
        ) : (
          <FontAwesomeIcon
            icon={faCirclePause}
            className={styles.icon}
            onClick={() => {
              setIsPlaying(false);
              // pause video
              videoRef.current.pause();
            }}
          />
        )
      ) : null}

      {links.length > 0 && !isMobile ? (
        <div
          className={clsx([
            styles.links,
            { [styles.linksRight]: index % 2 === 1 },
            "animate__animated",
            { animate__fadeInUp: inView && !isMobile }
          ])}
          ref={ref}
        >
          {links.map((link, index) => (
            <div>
              <FontAwesomeIcon icon={faExternalLink} />
              <a key={index} href={link.link} target="_blank">
                {link.text}
              </a>
            </div>
          ))}
        </div>
      ) : null}

      <Carousel.Caption className={styles.caption}>
        <h2 className={styles.title}>
          <span>{title}</span>
        </h2>
        <div>
          <Button
            ref={buttonRef}
            className={clsx(styles.button, "animate__animated", {
              animate__bounceIn: buttonInView
            })}
            onClick={() => {
              window.open(buttonLink, "_blank");
            }}
          >
            {buttonText}
          </Button>
        </div>
      </Carousel.Caption>
    </>
  );
};
